import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ResetPasswordForm from '../../../src/Components/ClientDashboard/ClientAuth/ResetPasswordForm';
import CookiePreferences from '../../../src/Components/ClientDashboard/auth/CookiePreferences';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/client/client_assets/css/ResetPasswordPage.css';
import '../../../src/pages/client/client_assets/css/common.css';

import Logo from '../../../src/pages/client/client_assets/img/logo.svg';
import GreenTick from '../../../src/pages/client/client_assets/img/green_tick.svg';
import lock_svg from '../../../src/pages/client/client_assets/img/Lock.svg';
import left_img from '../../../src/pages/client/client_assets/img/left_img.svg'; 
import { CopyrightContext } from '../../Components/CopyrightContext';

const ResetPasswordPage = () => {
    // const [showModal, setShowModal] = useState(false);

    const year = useContext(CopyrightContext)
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
            navigate('/');
        }
    }, [location, navigate]);

    // const toggleModal = () => {
    //     setShowModal(!showModal);
    // };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-left">
                <div className="glass-layer glass-top">
                    <img src={Logo} alt="Logo" className="logo" />
                </div>
                <div className='left_img'>
                                <img src={left_img} alt='brew_left' />
                            </div>
                            <div className="glass-layer glass-bottom">
                                <span className="cookie-preferences"
                                //  onClick={toggleModal}
                                 >
                                    © {year} Brew Your Brand.
                                </span>
                            </div>
            </div>
            <div className="forgot-password-right">
                <div className="forgot-password-form-container">
                    <ResetPasswordForm GreenTick={GreenTick} lock_svg={lock_svg} />
                </div>
            </div>
            {/* <CookiePreferences showModal={showModal} toggleModal={toggleModal} /> */}
        </div>
    );
};

export default ResetPasswordPage;
